export default function Logo({ size = "h-10 w-10", className = "", testid = "brand-logo" }) {
  return (
    <img src="/logo-512.png" alt="Shri Ji Clinic logo" crossOrigin="anonymous" data-testid={testid}
      className={`${size} rounded-xl bg-white object-contain shrink-0 ${className}`} />
  );
}
